import {
  AppkitDropdownItem,
  getAppkitDropdownSelection,
  setDropdownAriaLabel
} from '../../../shared/utils/appkit-dropdown.util';
import { DSTTaxYear } from '../../statement-tracker/create-disclosure/create-new/create-disclosure.service';

export function buildDstTaxYearItems(taxYears: DSTTaxYear[]): AppkitDropdownItem[] {
  return (taxYears || []).map((ty: DSTTaxYear, index: number) => ({
    value: index,
    label: ty.text.toString()
  }));
}

export function syncDstTaxYearItem(
  taxYearItems: AppkitDropdownItem[],
  taxYear: DSTTaxYear | undefined,
  taxYearLabel?: string
): AppkitDropdownItem | null {
  const label = taxYearLabel ?? taxYear?.text?.toString() ?? '';
  return taxYearItems.find((item) => item.label === label) || taxYearItems[0] || null;
}

export function resolveDstTaxYearFromEvent(
  event: any,
  taxYears: DSTTaxYear[]
): DSTTaxYear | undefined {
  const selected = getAppkitDropdownSelection(event);
  const label = selected?.label ?? '';
  return taxYears.find((item: DSTTaxYear) => item.text.toString() === label);
}

export function setDstTaxYearAriaLabel(item: any): string {
  return setDropdownAriaLabel(item, 'Tax Year');
}
